import React, { Component } from 'react';
import './Layout.css';

import Parse from '../../Parse';
import Header from '../../components/Common/Header';
import Sidebar from '../../components/Common/Sidebar';
import Footer from '../../components/Common/Footer';

class Layout extends Component {

    state = {
        class: 'Layout skin-blue sidebar-mini',
        sidebarOpen: true,
        configs: {},
        loading: false
    }

    componentDidMount() {
        Parse.Cloud.run("commonsConfig").then((res) => {
            this.setState({
                loading: false
            })
            this.setState({
                configs: res,
                loading: false
            })
        })
        .catch(error => {
            this.setState({
                loading: false
            })
            
        })
    }

    openSidebarHandler = () => {
        this.setState({
            sidebarOpen: !this.state.sidebarOpen,
            class: this.state.sidebarOpen ? 'Layout skin-blue sidebar-mini sidebar-open' : 'Layout skin-blue sidebar-mini'
        })
    }

    render () {
        return (
            <div className={this.state.class}>
                <Header openSidebar={this.openSidebarHandler}></Header>
                <Sidebar configs={this.state.configs} loading={this.state.loading}></Sidebar>
                    <div className="content-wrapper content-foodzaps">
                        {/* <section className="content-header">
                            <h1>
                                Dashboard
                                <small>Control panel</small>
                            </h1>
                        </section> */}
                        <section className="content">
                            {this.props.children}
                        </section>
                    </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default Layout;